import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Header from '../../../../../components/Header';
import Text from '../../../../../components/Text';
import Title from '../../../../../components/Title';
import List from '../../../../../components/List';
import Line from '../../../../../components/Line';
import Tabs from '../../../../../components/Tabs';
import TabsList from '../../../../../components/TabsList';
import TabsListItem from '../../../../../components/TabsListItem';
import Textarea from '../../../../../components/Textarea';
import CheckBox from '../../../Components/CheckBox';
import TabsCut from '../../../../../components/TabsCut';
import Actions from '../../../../../components/Actions';
import SvgIcon from '../../../../../components/SvgIcon';
import MobileMenuHeader from '../../../../../components/MobileMenuHeader';
import ResourceUploader from '../../../Components/ResourceUploader';
import { testStatusOptions } from '../../../../../utils/factories/testStatus';

const icons = ['text', 'ok', 'clip'];
const iconsComponents = icons.map((e) => <SvgIcon name={e} />);

const GeneralPage = ({
  nextClickHandler,
  menuItems,
  selectComponent,
  componentIndex,
  rules,
  backPath,
  testObject,
  locales,
  locales: {
    common,
    testing: {
      name,
      caseStudies,
      testAnalyse: {
        header,
        general: { text, title, list, actions },
        homepage: { tabs },
      },
    },
  },
}) => {
  const testType = `${testObject.test || 'homepage'}Result`;
  const [opened, setOpened] = useState(false);

  const { uploadingResult } = useSelector((state) => state.testDocument);

  const {
    testing: { updateTest },
  } = useDispatch();

  const onChange = (e) => {
    const updatedTest = {
      analyse: {
        ...testObject.analyse,
        resultsAndLearning: e.target.value,
      },
    };
    updateTest({ id: testObject.id, test: updatedTest });
  };

  const onCheck = (e) => {
    const { name: eName } = e.target;

    const updatedTest = {
      analyse: {
        ...testObject.analyse,
        status: eName,
      },
    };
    updateTest({ id: testObject.id, test: updatedTest });
  };

  return (
    <div className="bmc-page testing">
      <Header
        className="bmc-page-header--blue"
        subtitle={name}
        icon="icon-VP"
        locales={locales}
        title={header}
        menuItems={menuItems}
        onMenuItemClick={selectComponent}
        componentIndex={componentIndex}
        mobileMenuHeader={
          <MobileMenuHeader icon="testingActive" title={name} color="blue" />
        }
        rules={rules}
        backPath={backPath}
      />
      <Text>{[text[0], text[1]]}</Text>

      <Title align="left" text={title[0]} />
      <List items={list} icons={icons} />
      <Line />
      <h2 className="bmc-page-title">
        <span className="bmc-page-title--blue">{title[2]}</span> {title[3]}
      </h2>

      <Text align="center">{[text[4]]}</Text>

      <Tabs
        tabs={[common.yourStrategy, common.caseStudy]}
        withBlur
        className="margin-top-60 bmc-page-tabs--blue"
      >
        {[
          <div key="strategy">
            <TabsList formStyle>
              <TabsListItem
                divider={false}
                className="mb-10"
                title={tabs.enterResultsLearning}
                subtitle={tabs.enterResultsLearningSub}
                icon={iconsComponents[0]}
                text={
                  // eslint-disable-next-line
                  <Textarea
                    onChange={onChange}
                    value={testObject.analyse.resultsAndLearning}
                    delay={700}
                    placeholder={tabs.resultsAndLearningPlaceholder}
                  />
                }
              />
            </TabsList>

            <TabsList formStyle>
              <TabsListItem
                divider={false}
                className="mb-10"
                title={tabs.isAssumptionValidated}
                subtitle={tabs.isAssumptionValidatedSub}
                icon={iconsComponents[1]}
                text={
                  // eslint-disable-next-line
                  <div className="checkbox-wrapper column">
                    {testStatusOptions
                      .filter((testOption) =>
                        ['valid', 'invalid', 'unsure'].includes(
                          testOption.value,
                        ),
                      )
                      .map((testOption) => (
                        <CheckBox
                          isChecked={
                            testObject.analyse.status === testOption.value
                          }
                          onCheck={onCheck}
                          key={testOption.value}
                          title={testOption.label}
                          name={testOption.value}
                        />
                      ))}
                  </div>
                }
              />
            </TabsList>

            <TabsList formStyle>
              <TabsListItem
                divider={false}
                title={tabs.supportingDocuments}
                subtitle={tabs.supportingDocumentsSub}
                icon={iconsComponents[2]}
                text={
                  // eslint-disable-next-line
                  <ResourceUploader
                    documentType="result"
                    uploading={uploadingResult}
                  />
                }
              />
            </TabsList>
          </div>,
          <Tabs
            key="tabs"
            tabs={caseStudies.map((e) => e.name)}
            className="bmc-page-tabs--black bmc-page-tabs--inner"
          >
            {caseStudies.map((item, index) => (
              <div key={index}>
                <TabsCut
                  opened={opened}
                  setOpened={setOpened}
                  caseStudy={item}
                />

                <TabsListItem
                  title={tabs.enterResultsLearning}
                  text={item[testType].text}
                  icon={iconsComponents[0]}
                />
                <TabsListItem
                  divider={false}
                  title={tabs.bmcBlocks}
                  icon={iconsComponents[2]}
                >
                  <div className="bmc-page-tabs-content-list-item-text">
                    <div className="checkbox-wrapper column">
                      {testStatusOptions
                        .filter((testOption) =>
                          ['valid', 'invalid', 'unsure'].includes(
                            testOption.value,
                          ),
                        )
                        .map((testOption) => (
                          <CheckBox
                            isChecked={
                              item[testType].status === testOption.value
                            }
                            isPreview
                            key={testOption.value}
                            title={testOption.label}
                            name={testOption.value}
                          />
                        ))}
                    </div>
                  </div>
                </TabsListItem>
              </div>
            ))}
          </Tabs>,
        ]}
      </Tabs>
      <Actions
        nextClickHandler={nextClickHandler}
        buttonName={common.next}
        tooltipIfDisabled={actions.tooltipIfDisabled}
      />
    </div>
  );
};

export default GeneralPage;
